import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateFormatterService {

  /**
   * Formatiert die Eingabe automatisch mit Punkten (tt.mm.jjjj)
   * @param input Das Input-Element
   */
  formatDateOnInput(input: HTMLInputElement): void {
    // Remove everything but digits and points
    let inputValue: string = input.value.replace(/[^\d.]/g, '');

    // Automatically add points
    inputValue = inputValue.replace(/^(\d{2})(\d)/, '$1.$2');
    inputValue = inputValue.replace(/^(\d{2}\.\d{2})(\d)/, '$1.$2');

    inputValue = inputValue.substring(0, 10);

    input.value = inputValue;
  }
}
